<template>
  <div class="customer-info app-panel blank-v blank-h">
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="备注" prop="note">
        <el-input v-model="form.note" type="textarea" :rows="10"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import CustomerService from '@/io/customer.js';

  export default {
    name: 'CustomerInfo',
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: '',
          sex: 1,
          age: '',
          note: ''
        },
        rules: {
          name: [
            {
              required: true, message: '请输入客户姓名'
            }
          ],
          sex: [
            {
              required: true, message: '请输入客户性别'
            }
          ],
          age: [
            {
              required: true, message: '请输入客户年龄'
            }
          ],
          note: [
            {
              required: true, message: '请输入客户备注'
            }
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initDatas();
          }
        },
        immediate: true
      }
    },
    methods: {
      initDatas() {
        CustomerService.info(this.id).then(res => {
          this.form.note = res.data.attr_data.project_customer_attr_other;
        }).catch(() => {});
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            CustomerService.edit(
              this.id,
              this.form.note
            ).then(() => {
              this.$message.success('编辑成功');
              this.cancel();
            }).catch(() => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          path: '/customer_manage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>